import { render, staticRenderFns } from "./tarifa-editor-herramientas.vue?vue&type=template&id=04dda0d8&scoped=true"
import script from "./tarifa-editor-herramientas.vue?vue&type=script&lang=js"
export * from "./tarifa-editor-herramientas.vue?vue&type=script&lang=js"
import style0 from "./tarifa-editor-herramientas.vue?vue&type=style&index=0&id=04dda0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dda0d8",
  null
  
)

export default component.exports